<p>process-collection-documents works!</p>
